/**
 * US Timezones for prospect and task filtering
 * Using IANA timezone format for reliable date/time calculations
 */
export const US_TIMEZONES = [
  { label: "Eastern Time (ET)", value: "America/New_York" },
  { label: "Central Time (CT)", value: "America/Chicago" },
  { label: "Mountain Time (MT)", value: "America/Denver" },
  { label: "Arizona (no DST)", value: "America/Phoenix" },
  { label: "Pacific Time (PT)", value: "America/Los_Angeles" },
  { label: "Alaska Time (AKT)", value: "America/Anchorage" },
  { label: "Hawaii Time (HT)", value: "Pacific/Honolulu" },
] as const;

export type USTimezoneValue = (typeof US_TIMEZONES)[number]["value"];

/**
 * Get the display label for a timezone value
 */
export const getTimezoneLabel = (value: string): string => {
  const tz = US_TIMEZONES.find((tz) => tz.value === value);
  return tz?.label ?? value;
};

/**
 * Format the current local time for a given IANA timezone
 */
export const formatLocalTime = (timezone: string): string => {
  try {
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      hour12: true,
      minute: "2-digit",
      timeZone: timezone,
    }).format(new Date());
  } catch {
    return "";
  }
};
